export default __webpack_public_path__ + "static/media/Search.bbd9413a.png";